import ko from './locale-ko'
import en from './locale-en'
import { localize, extend } from 'vee-validate'
import { getLocale } from '@/libs/util'
import {
  digits,
  required,
  email,
  max,
  min,
  confirmed,
  excluded
} from 'vee-validate/dist/rules'

import pageNum from './rules/page_num'
import asc from './rules/asc'
import dateFormat from './rules/date_format'
import notComma from './rules/not_comma'
import url from './rules/url'

export default () => {
  return {
    init: () => {
      extend('required', required)
      extend('email', email)
      extend('max', max)
      extend('min', min)
      extend('confirmed', confirmed)
      extend('digits', digits)
      extend('excluded', excluded)

      extend('not_comma', notComma)
      extend('page_num', pageNum)
      extend('asc', asc)
      extend('date_format', dateFormat)
      extend('url', url)

      localize({ ko, en })
      localize(getLocale())
    }
  }
}
